// Eventos en los que participa Meyle.
// Cada evento debe incluir id único, título, organizador, fecha (YYYY-MM-DD),
// modalidad ('presencial' | 'virtual' | 'hibrido'),
// rol ('sponsor' | 'expositor' | 'organizador'),
// descripción, imagen, link externo y bandera `destacado`.

export const eventos = [
  {
    id: 'asaga-2026-05',
    titulo: 'Jornada de Mantenimiento en la Industria Aceitera',
    organizador: 'ASAGA',
    organizadorNombre: 'Asociación Argentina de Grasas y Aceites',
    fecha: '2026-05-14',
    modalidad: 'hibrido',
    descripcion: 'Jornada de actualización sobre mantenimiento en la industria aceitera.',
    imagen: '/assets/eventos/asaga-2026-05.webp',
    link: 'https://asaga.org.ar/evento/taller-sobre-mantenimiento-en-la-industria-aceitera-i-2/?utm_source=email_marketing&utm_admin=11108&utm_medium=email&utm_campaign=Lo_que_tens_que_saber_de_la_agroindustria_hoy',
    destacado: true
  },
  {
    id: 'asaga-world-congress-2025',
    titulo: 'World Congress on Oils & Fats 2025',
    organizador: 'ASAGA',
    organizadorNombre: 'Asociación Argentina de Grasas y Aceites',
    fecha: '2025-09-15',
    fechaFin: '2025-09-19',
    modalidad: 'presencial',
    descripcion: 'Evento de referencia mundial para la industria de grasas y aceites. Feria comercial con más de 2000 asistentes y proveedores en 1500 m², con temáticas de crushing de semillas oleaginosas, aplicaciones comestibles y nuevas tecnologías. Sede: Salón Metropolitano, Rosario.',
    imagen: null,
    link: 'https://www.asagaworldcongress2025.com',
    destacado: false
  },
  {
    id: 'ksb-capacitacion-gerdau-2026',
    titulo: 'Capacitación KSB — Mantenimiento de Bombas e Industria',
    organizador: 'Meyle SRL',
    organizadorNombre: 'Meyle Ingeniería y Servicios SRL',
    fecha: '2026-03-12',
    fechaFin: '2026-03-13',
    modalidad: 'presencial',
    descripcion: 'Capacitación presencial sobre mantenimiento de bombas y conocimiento general de bombas y válvulas industriales KSB, realizada en las instalaciones de Gerdau Sipar.',
    imagen: null,
    link: null,
    destacado: false
  }
];

const MODALIDAD_LABEL = {
  presencial: 'Presencial',
  virtual: 'Virtual',
  hibrido: 'Híbrido'
};

const ROL_LABEL = {
  sponsor: 'Sponsor',
  expositor: 'Expositor',
  organizador: 'Organizador'
};

export const modalidadLabel = (m) => MODALIDAD_LABEL[m] || m;
export const rolLabel = (r) => ROL_LABEL[r] || r;

// Devuelve fecha parseada como Date local (sin desfase por timezone)
export const parseFechaEvento = (fechaIso) => {
  const [y, m, d] = fechaIso.split('-').map(Number);
  return new Date(y, m - 1, d);
};

// Fecha "viva" mínima: hoy a las 00:00 local
const startOfToday = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};

export const isEventoFuturo = (evento) =>
  parseFechaEvento(evento.fecha) >= startOfToday();

export const eventosFuturos = () =>
  eventos
    .filter(isEventoFuturo)
    .sort((a, b) => parseFechaEvento(a.fecha) - parseFechaEvento(b.fecha));

export const eventosPasados = () =>
  eventos
    .filter((e) => !isEventoFuturo(e))
    .sort((a, b) => parseFechaEvento(b.fecha) - parseFechaEvento(a.fecha));

export const proximoEvento = () => {
  const futuros = eventosFuturos();
  return futuros.length > 0 ? futuros[0] : null;
};

const MESES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
];

export const formatFechaLarga = (fechaIso) => {
  const d = parseFechaEvento(fechaIso);
  return `${d.getDate()} de ${MESES[d.getMonth()]} de ${d.getFullYear()}`;
};

export const formatFechaCorta = (fechaIso) => {
  const d = parseFechaEvento(fechaIso);
  const mesCorto = MESES[d.getMonth()].slice(0, 3);
  return `${d.getDate()} ${mesCorto} ${d.getFullYear()}`;
};
